import React from 'react';
import { Button, Divider, Typography, Space } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

export default function BoardHeader({
  sidebarCollapsed,
  setSidebarCollapsed,
  filteredCount,
  totalCount,
}) {
  return (
    <div style={{
      background: 'white',
      borderRadius: '8px',
      padding: '12px 16px',
      marginBottom: '16px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      border: '1px solid #e8e8e8'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div>
          <Title level={4} style={{ margin: 0, color: '#262626', fontSize: '16px' }}>
            Kanban Board
          </Title>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            Manage your project tasks efficiently
          </Text>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            {filteredCount} of {totalCount} tasks
          </Text>
          <Divider type="vertical" />
          <Button
            type="text"
            icon={sidebarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            style={{ color: '#8c8c8c' }}
          >
            {sidebarCollapsed ? 'Show Sidebar' : 'Hide Sidebar'}
          </Button>
        </div>
      </div>
    </div>
  );
}


